import { ConfigService } from "../services/config.service";

export class MssAdresseValidator {
	static validate(adresse: string | undefined): boolean {
		const trimmed = adresse?.trim() ?? "";
		if (!trimmed) return false;

		const regex = this.regex;
		if (!regex) {
			return false;
		}

		return regex.test(trimmed);
	}

	private static _regex: RegExp | null | undefined = undefined;

	static get regex(): RegExp | null {
		if (this._regex !== undefined) return this._regex;

		const pattern = ConfigService.config.moduleRecherchePS?.autoSuggestionModule?.emailMSSValidationRegex;

		if (pattern) {
			this._regex = new RegExp(decodeURIComponent(pattern));
			return this._regex;
		}

		this._regex = null;
		return null;
	}
}
